import { cartLinesListHeaderStyles } from "@insite/content-library/Components/CartLinesListHeader";
import { COLORS } from "@tCentro/theme/design";
import { css } from "styled-components";

cartLinesListHeaderStyles.condensedCheckbox = {
    css:css`
        span[role=checkbox] {
        border: 2px solid #9E9D9E !important;
        border-radius: 0 !important;
        &:focus {
            box-shadow: none !important;
        }
        &[aria-checked=true]{
            background: none !important;
            color: ${COLORS.black} !important;
            border: 2px solid ${COLORS.black} !important;
        }
    }
    `,
}